import React from 'react';
import useUserContext from 'Context/UserContext';
import { pickComponentAndProps } from 'Helpers/Affordances';
import fr from 'facet-rest';
import ClientExperienceSavesWithProvider from './ClientExperienceSavesRoot';

const ClientExperiencePicker = () => {
  const { agentResource } = useUserContext();
  const { component: ClientExperienceComponent, props: componentProps } = pickComponentAndProps(agentResource, {
    [fr.relationships.escalatedHousehold.name]: [ClientExperienceSavesWithProvider, {}],
    [fr.relationships.default.name]: [() => null, {}],
  });

  return (
    <ClientExperienceComponent {...componentProps} />
  );
};

export default ClientExperiencePicker;
